"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClipboardAddFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 5v4H10V5H6v25h20V5zM11 18h4v-4h2v4h4v2h-4v4h-2v-4h-4z" }),
        React.createElement("path", { d: "M20 6V4.18a2.76 2.76 0 00-.62-2.1A4.45 4.45 0 0016 1a4.48 4.48 0 00-3.39 1.08 2.76 2.76 0 00-.61 2.1V7h8z" })));
}
exports.default = SvgClipboardAddFilled;
//# sourceMappingURL=ClipboardAddFilled.js.map